export default "__VITE_ASSET__CbxAG9VT__"